<script lang="ts">
  import type { CustomerService } from "$lib/types/customerService";
  import KundeserviceBanner from "$lib/KundeserviceBanner.svelte";
  import FAQs from "$lib/FAQs.svelte";
  import MetaData from "$lib/MetaData.svelte";
  import Breadcrumb from "$lib/Breadcrumb.svelte";
  import Lead from "$lib/Lead.svelte";
  import type { Faq, InternalLinkingModule } from "$lib/types/shared";
  import InternalLinking from "$lib/InternalLinking.svelte";

  interface Props {
    data: {
      customerService: CustomerService;
      faqs: Faq[];
      internalLinkingModule: InternalLinkingModule;
    };
  }

  let { data }: Props = $props();

  let { customerService, faqs } = data;

  let internalLinkingModule: InternalLinkingModule = $derived(data?.internalLinkingModule);
</script>

<MetaData
  data={{
    title: customerService?.title,
    description: customerService?.subtitle,
  }}
/>

<Breadcrumb
  breadcrumbs={[
    { label: "Forside", href: "/" },
    { label: "Kundeservice", href: "/privat/kundeservice" },
  ]}
/>

<section>
  <h1 class="mx-edge-x text-pretty mb-6">{customerService?.title}</h1>
  <Lead class="mx-edge-x max-w-prose">{customerService?.subtitle}</Lead>
  <KundeserviceBanner
    showNameInput={false}
    showMessageInput={false}
    title="Har du andre spørsmål, ta gjerne kontakt med oss"
    class="landscape:mr-edge-x landscape:rounded-[0_1rem_1rem_0]"
  />
</section>

{#if faqs?.length > 0}
  <FAQs faq_category={faqs} />
{/if}

{#if internalLinkingModule}
  <InternalLinking module={internalLinkingModule} />
{/if}
